import React from 'react'
import SplitPane from 'react-split-pane'

import InputSection from '../../views/Input'
import OutputSection from '../../views/Output'
import IllustrationSection from '../../views/Illustration'

const TabletView = () => {
  return (
    <SplitPane split="horizontal" defaultSize="33%" minSize="33%">
      <InputSection />
      <SplitPane split="horizontal" defaultSize="33%" minSize="33%">
        <IllustrationSection />
        <OutputSection />
      </SplitPane>
    </SplitPane>
  )
}

export default TabletView
